import { action } from '@ember/object';

import type { PopupData } from 'webapp-types';

import didInsert from 'webapp/modifiers/did-insert';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class CommonPopupApiResponseComponent extends PopupInnerModalComponent<PopupData.Common.ApiResponse> {
	get data() {
		return this.popupData.data;
	}

	get dataString() {
		return this.data as string;
	}

	get title() {
		return this.popupData.title;
	}

	get isHtml() {
		return this.popupData.isHtml;
	}

	get wrapText() {
		return this.popupData.wrapText;
	}

	@action
	insertHtml(node: HTMLElement) {
		(this.data as JQuery<HTMLElement>).appendTo($(node));
		this.reposition();
	}
	<template>
		<div class="title">
			{{this.title}}
		</div>
		<div class="content">
			{{#if this.isHtml}}
				<div class="html-ct" {{didInsert this.insertHtml}}></div>
			{{else}}
				<pre class={{if this.wrapText "wrap"}}>{{this.dataString}}</pre>
			{{/if}}
		</div>
	</template>
}
